import React from 'react';
import classNames from 'classnames';
const styles = require('./Skills.module.scss');

interface Props {
  mustHaveSkills: { id: number; name: string }[];
  otherRequiredSkills: { id: number; name: string }[];
  niceToHaveSkills: { id: number; name: string }[];
}

export default function Skills(props: Props) {
  const renderSkills = (title, skills, border, color) => {
    return (
      skills && skills.length > 0 && (
        <div className={styles.skillRow}>
          <div className={classNames(styles.skillLabel, color)}>{title}:</div>
          <div className={styles.skillChips}>
            {skills.map(skill => (
              <div key={skill.id} className={classNames(styles.skillsItem, border, color)}>
                {skill.name}
              </div>
            ))}
          </div>
        </div>
      )
    );
  };

  const requiredSkills = [...props.mustHaveSkills, ...props.otherRequiredSkills];

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>Skills</h2>
      <hr className={styles.line} />
      <div className={styles.skillsContainer}>
        {requiredSkills.length > 0 &&
          renderSkills('Required', requiredSkills, styles.mustHaveBorder, styles.mustHave)}
        {props.niceToHaveSkills.length > 0 &&
          renderSkills(
            'Nice to have',
            props.niceToHaveSkills,
            styles.niceToHaveBorder,
            styles.niceToHave
          )}
      </div>
    </div>
  );
}
